import { IonIcon } from '@ionic/react'
import { useStore, useStoreMap } from 'effector-react'
import { alertCircleSharp } from 'ionicons/icons'
import { Link } from 'react-router-dom'
import { mainBalance } from '~/entities/MainBalance'
import { notificationModalOpen } from '~/shared/lib/notificationModal'
import { RubIcon } from '~/shared/ui/icons'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { myPalette } from '~/shared/ui/theme'
import { Chip, Amount } from './styled'

type CurrentBalanceProps = {
  disabled?: boolean
}

export function CurrentBalance({ disabled }: CurrentBalanceProps) {
  const amount = useStoreMap(
    mainBalance.$currentBalance,
    (currentBalance) => currentBalance?.getAmount() || 0,
  )

  const customerMeError = useStore(mainBalance.$customerMeError)

  const isGetCurrentBalancePending = useStore(
    mainBalance.getCurrentBalanceFx.pending,
  )
  const isGetCustomerMePending = useStore(mainBalance.getCustomerMeFx.pending)

  const handleShowErrorModal = () => {
    notificationModalOpen({
      title: 'Ошибка!',
      description: customerMeError || '',
      variant: 'error' as const,
    })
  }

  if (isGetCurrentBalancePending || isGetCustomerMePending) {
    return (
      <Chip>
        <ProgressBlock
          height={16}
          size={16}
          color={myPalette.midnightBlue.main}
        />
      </Chip>
    )
  }

  if (customerMeError)
    return (
      <Chip onClick={handleShowErrorModal}>
        <IonIcon
          icon={alertCircleSharp}
          style={{ color: myPalette.coral.main, margin: 0 }}
        />
      </Chip>
    )

  return (
    <Link
      to='/balance'
      data-testid='current-balance-link'
      style={{
        textDecoration: 'none',
        ...(disabled ? { pointerEvents: 'none' } : {}),
      }}
    >
      <Chip>
        <RubIcon />
        <Amount>{amount.toLocaleString()}</Amount>
      </Chip>
    </Link>
  )
}
